"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FroalaEditorFunctionality = /** @class */ (function (_super) {
    __extends(FroalaEditorFunctionality, _super);
    function FroalaEditorFunctionality(props) {
        var _this = _super.call(this, props) || this;
        _this._initEvents = [];
        // Tag on which the editor is initialized.
        _this.tag = null;
        _this.defaultTag = "div";
        _this.listeningEvents = [];
        // Jquery wrapped element.
        _this.element = null;
        // Editor element.
        _this.editor = null;
        // Editor options config
        _this.config = {
            immediateReactModelUpdate: false,
            reactIgnoreAttrs: null
        };
        _this.editorInitialized = false;
        _this.SPECIAL_TAGS = ["img", "button", "input", "a"];
        _this.INNER_HTML_ATTR = "innerHTML";
        _this.hasSpecialTag = false;
        _this.oldModel = null;
        return _this;
    }
    // Before first time render.
    FroalaEditorFunctionality.prototype.componentWillMount = function () {
        this.tag = this.props.tag || this.defaultTag;
    };
    // After first time render.
    FroalaEditorFunctionality.prototype.componentDidMount = function () {
        var tagName = this.el.tagName.toLowerCase();
        if (this.SPECIAL_TAGS.indexOf(tagName) !== -1) {
            this.tag = tagName;
            this.hasSpecialTag = true;
        }
        if (this.props.onManualControllerReady) {
            this.generateManualController();
        }
        else {
            this.createEditor();
        }
    };
    FroalaEditorFunctionality.prototype.componentWillUnmount = function () {
        this.destroyEditor();
    };
    FroalaEditorFunctionality.prototype.componentDidUpdate = function () {
        if (JSON.stringify(this.oldModel) === JSON.stringify(this.props.model)) {
            return;
        }
        this.setContent();
    };
    FroalaEditorFunctionality.prototype.createEditor = function () {
        var _this = this;
        if (this.editorInitialized) {
            return;
        }
        this.config = this.props.config || this.config;
        this.element = this.el;
        if (this.props.model) {
            this.element.innerHTML = this.props.model;
        }
        this.setContent(true);
        // Default initialized.
        this.registerEvent("initialized", this.config.events && this.config.events.initialized);
        // Check if events are set.
        if (!this.config.events)
            this.config.events = {};
        this.editor = new FroalaEditor(this.element, this.config);
        this.config.events.initialized = function () { return _this.initListeners(); };
        // Call init events.
        if (this._initEvents) {
            for (var i = 0; i < this._initEvents.length; i++) {
                this._initEvents[i].call(this.editor);
            }
        }
    };
    FroalaEditorFunctionality.prototype.setContent = function (firstTime) {
        if (this.props.model || this.props.model === "") {
            this.oldModel = this.props.model;
            if (this.hasSpecialTag) {
                this.setSpecialTagContent();
            }
            else {
                this.setNormalTagContent(firstTime);
            }
        }
    };
    FroalaEditorFunctionality.prototype.setNormalTagContent = function (firstTime) {
        var _this = this;
        var self = this;
        function htmlSet() {
            self.editor.html && self.editor.html.set(self.props.model || "");
            if (self.editorInitialized && self.editor.undo) {
                //This will reset the undo stack everytime the model changes externally. Can we fix this?
                self.editor.undo.reset();
                self.editor.undo.saveStep();
            }
        }
        if (firstTime) {
            if (this.config.initOnClick) {
                this.registerEvent("initializationDelayed", function () {
                    htmlSet();
                });
                this.registerEvent("initialized", function () {
                    _this.editorInitialized = true;
                });
            }
            else {
                this.registerEvent("initialized", function () {
                    _this.editorInitialized = true;
                    htmlSet();
                });
            }
        }
        else {
            htmlSet();
        }
    };
    FroalaEditorFunctionality.prototype.setSpecialTagContent = function () {
        var tags = this.props.model;
        // add tags on element
        if (tags) {
            for (var attr in tags) {
                if (tags.hasOwnProperty(attr) && attr !== this.INNER_HTML_ATTR) {
                    this.element.setAttribute(attr, tags[attr]);
                }
            }
            if (tags.hasOwnProperty(this.INNER_HTML_ATTR)) {
                this.element.innerHTML = tags[this.INNER_HTML_ATTR];
            }
        }
    };
    FroalaEditorFunctionality.prototype.destroyEditor = function () {
        var _a;
        if (this.element) {
            ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.destroy) && this.editor.destroy();
            this.listeningEvents.length = 0;
            this.element = null;
            this.editorInitialized = false;
        }
    };
    FroalaEditorFunctionality.prototype.getEditor = function () {
        if (this.element) {
            return this.editor;
        }
        return null;
    };
    FroalaEditorFunctionality.prototype.generateManualController = function () {
        var self = this;
        var controls = {
            initialize: function () { return self.createEditor.call(self); },
            destroy: function () { return self.destroyEditor.call(self); },
            getEditor: function () { return self.getEditor.call(self); }
        };
        this.props.onManualControllerReady(controls);
    };
    FroalaEditorFunctionality.prototype.updateModel = function () {
        if (!this.props.onModelChange) {
            return;
        }
        var modelContent = "";
        if (this.hasSpecialTag) {
            var attributeNodes = this.element.attributes;
            var attrs = {};
            for (var i = 0; i < attributeNodes.length; i++) {
                var attrName = attributeNodes[i].name;
                if (this.config.reactIgnoreAttrs &&
                    this.config.reactIgnoreAttrs.indexOf(attrName) !== -1) {
                    continue;
                }
                attrs[attrName] = attributeNodes[i].value;
            }
            if (this.element.innerHTML) {
                attrs[this.INNER_HTML_ATTR] = this.element.innerHTML;
            }
            modelContent = attrs;
        }
        else {
            var returnedHtml = this.editor.html.get();
            if (typeof returnedHtml === "string") {
                modelContent = returnedHtml;
            }
        }
        this.oldModel = modelContent;
        this.props.onModelChange(modelContent);
    };
    FroalaEditorFunctionality.prototype.initListeners = function () {
        var self = this;
        // bind contentChange and keyup event to froalaModel
        console.log("Editor: ", __assign({}, this.editor));
        if (this.editor && this.editor.events) {
            this.editor.events.on("contentChanged", function () {
                self.updateModel();
            });
            if (this.config.immediateReactModelUpdate) {
                this.editor.events.on("keyup", function () {
                    self.updateModel();
                });
            }
        }
    };
    // register event on jquery editor element
    FroalaEditorFunctionality.prototype.registerEvent = function (eventName, callback) {
        if (!eventName || !callback) {
            return;
        }
        if (eventName === "initialized") {
            if (!this._initEvents)
                this._initEvents = [];
            this._initEvents.push(callback);
        }
        else {
            if (!this.config.events) {
                this.config.events = {};
            }
            this.config.events[eventName] = callback;
        }
    };
    return FroalaEditorFunctionality;
}(react_1.default.Component));
exports.default = FroalaEditorFunctionality;
